import { useaxios } from "../../../utils/useaxios";
export default (category_name, category_start_code, category_id) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    initDispatch({ type: 'loadingTrue' });
    useaxios('category/update.php', { category_name, category_start_code, category_id }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        } else if (res.status == "ok") {
            setrecaller(recaller + 1);
        } else {
            alert('تکایە دڵنیابە لە داخڵکردنی زانیاری دروست');
            initDispatch({ type: 'loadingFalse' });
        }
        // setloading(false);
    });
}